import { http, http_main } from '@/environment/environment';

class GameReleaseService
{
    createGameRelease(gameId: string, userId: string, jwtToken:string, data: any): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        const config = {
            onUploadProgress: function(progressEvent) {
                const percentCompleted = Math.round((progressEvent.loaded / progressEvent.total)*100);
                const bar = document.getElementById('progress-bar');
                bar.setAttribute('value', percentCompleted.toString());
                bar.previousElementSibling.textContent = `${percentCompleted}%`
                if (percentCompleted === 100) {
                  bar.previousElementSibling.textContent = `Finalizing Upload...`
                }
                return percentCompleted;
            }
        }
        return http.post(`games/${gameId}/releases?userId=${userId}`, data, config);
    }

    submitGame(gameId: string, userId: string, data: any): Promise<any> {
        return http.post(`games/${gameId}/submit?userId=${userId}`, data);
    }

    publishGame(gameId: string, userId: string, jwtToken:string, network: string): Promise<any> {
        if(network === 'testnet'){
            http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http.post(`games/${gameId}/publish?userId=${userId}`);
        }else{
            http_main.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http_main.post(`games/${gameId}/publish?userId=${userId}`);
        }
    }

    reviewGame(gameId: string, userId: string): Promise<any> {
        return http.put(`games/${gameId}/review?userId=${userId}`);
    }

    getReleasesList(gameId: string, userId: string, jwtToken: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.get(`games/${gameId}/releases?userId=${userId}&platform=Any`);
    }

    deleteRelease(gameId:string, userId:string, jwtToken: string, version: string, platform: string):Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.delete(`games/${gameId}/releases/${platform}/${version}?userId=${userId}`);
    }

    // getReleasesListByPlatform(gameId: string, userId: string, jwtToken: string, platform: string): Promise<any> {
    //     http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    //     return http.get(`games/${gameId}/releases?userId=${userId}`);
    // }

    getSubmissionsList(userId: string, status: string): Promise<any> {
        return http.get(`games/${userId}/submissions?status=${status}`);
    }

    getGameSubmission(gameId: string, userId: string, jwtToken: string, status: string): Promise<any> {
        http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
        return http.get(`submissions/${gameId}?userId=${userId}&status=${status}`);
    }

    importGameToMainnet(gameId: string, userId: string, jwtToken:string, network: string): Promise<any> {
        if(network === 'testnet'){
            http.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http.post(`mainnet/game/${gameId}/import?userId=${userId}`);
        }else{
            http_main.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
            return http_main.post(`mainnet/game/${gameId}/import?userId=${userId}`);
        }
    }
}

export default new GameReleaseService();